<template>
  <BaseContainer>
    <div class="mx-5 mt-3 mb-24 flex flex-col gap-3">
      <div class="flex items-end justify-between gap-3 flex-wrap">
        <div>
          <h2 class="text-lg font-bold text-primary">
            Cartes clients
          </h2>
          <p class="text-[13px] text-slate-500">
            Gérez les cartes de fidélité de vos patients.
          </p>
        </div>
        <button
          type="button"
          class="inline-flex items-center gap-2 bg-primary text-white rounded-lg px-4 py-2 text-sm font-semibold transition-opacity hover:opacity-90"
          @click="goToMigration"
        >
          <Icon name="mdi-card-plus-outline" :size="18" color="#fff" />Créer une carte
        </button>
      </div>

      <BaseCard>
        <LoyaltyCardConsumersTable :resource-id="program.programmable_id" />
      </BaseCard>
    </div>
  </BaseContainer>
</template>

<script lang="ts" setup>
import {useRoute, useRouter} from "vue-router";
import BaseContainer from '@/core/components/base/BaseContainer.vue';
import BaseCard from '@/core/components/base/BaseCard.vue';
import Icon from "@/core/components/icon/Icon.vue";
import LoyaltyCardConsumersTable from '@/program/components/program-consumers/LoyaltyCardConsumersTable.vue';
import {Program} from "@/program/interfaces/Program";

const props = defineProps<{
    program: Program
}>();

const route = useRoute();
const router = useRouter();

const goToMigration = () => {
    router.push({
        name: "program.loyalty-card.migration",
        params: {programId: route.params.programId, loyaltyCardId: props.program.programmable_id}
    });
};
</script>
